<template>
    <div v-if="info && canShow('中医体质辨识（商业版）') && info.tizhi_text_array && info.tizhi_qingxiang_text_array">
        <!-- 打印模式 -->
        <template v-if="isPrint">
            <div class="face-analysis-title">中医体质辨识</div>
            <div class="dotted-line"></div>

            <div class="phy-print-constitution">
                <div class="phy-print-left">
                    <span class="phy-print-label">主体质：</span>
                    <span class="phy-print-value">{{ info.tizhi_text_array.join('、') }}</span>
                </div>
                <div class="phy-print-right">
                    <span class="phy-print-label">倾向体质：</span>
                    <span class="phy-print-value">{{ info.tizhi_qingxiang_text_array.filter(Boolean).join('、') }}</span>
                </div>
            </div>

            <div v-if="info.jibing.fenxi">
                <div class="phy-print-section-title">健康状态分析</div>
                <div class="phy-print-section-text">{{ info.jibing.fenxi }}</div>
            </div>

            <div v-if="info.jibing.jibing">
                <div class="phy-print-disease" v-for="(item, index) in info.jibing.jibing" :key="'jibing-' + index">
                    <div class="phy-print-disease-category">{{ item.sysName }}</div>
                    <div class="phy-print-disease-line"><span class="bold-label">影响系统：</span>{{ item.sysName }}</div>
                    <div class="phy-print-disease-line"><span class="bold-label">易感疾病：</span>{{ item.sd }}</div>
                    <div class="phy-print-disease-line"><span class="bold-label">体质原因：</span>{{ item.cp }}</div>
                </div>
            </div>
        </template>

        <!-- 正常模式 -->
        <template v-else>
            <div class="tips"></div>
            <div class="sick-box">
                <div class="risk">中医体质辨识</div>
            </div>
            <div class="assessment">
                <div class="new-title">您当前的中医体质</div>
                <div class="sick-list flex flex-w">
                    <div v-for="(item, index) in info.tizhi_text_array" :key="'main20-' + index" >
                        <div class="new-sick tiz-sick">
                            {{ item }}<span>(主)</span>
                        </div>
                    </div>
                    <div  v-for="(item, index) in info.tizhi_qingxiang_text_array" :key="'phy20-' + index">
                        <div class="new-sick tiz-sick" v-if="item">
                            {{ item }}<span>(兼)</span>
                        </div>
                    </div>
                </div>

                <div class="business-analysis-box" v-if="info.jibing.fenxi">
                    <div class="business-analysis-title">健康状态分析</div>
                    <div class="business-analysis-desc">
                        {{ info.jibing.fenxi }}
                    </div>
                </div>

                <div class="table-mark" v-if="info.jibing.jibing">
                    <table class="newre-table business-table">
                        <thead>
                            <tr>
                                <th style="width: 24%;">影响系统</th>
                                <th style="width: 38%;">易感疾病</th>
                                <th style="width: 38%;">体质原因</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in info.jibing.jibing" :key="'jibing-' + index">
                                <td class="bold-text">{{ item.sysName }}</td>
                                <td class="left-align-text">{{ item.sd }}</td>
                                <td class="left-align-text">{{ item.cp }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </template>
    </div>
</template>
<script>
import { moduleMixin } from '../helpers';
import { mapState } from 'vuex';
export default {
    name: 'ReportPhysiqueBusiness',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info'])
    },
    methods: {
        chineseNum(i) {
            const c = '一二三四五六七八九十';
            return c[i] != null ? c[i] : i + 1;
        }
    }
};
</script>
<style lang="scss" scoped>
@import './PhysiqueBusiness.scss';
</style>
